import React from 'react';
import { PhotoPlaceholder } from './PhotoPlaceholder';

export const Photo = ({ photo, onOpen }) =>
    photo.url ? (
        <button
            type="button"
            className="ph ph-img"
            onClick={() => onOpen && onOpen(photo.url)}
            aria-label={photo.label}
        >
            <img src={photo.url} alt={photo.label} loading="lazy" />
        </button>
    ) : (
        <PhotoPlaceholder label={photo.label} />
    );
